<template>
  <!-- 最新消息首页 -->
  <div class="container">
    <content-template>
      <template slot="left">聯絡我們</template>
      <template slot="right">
        <li class="media-navbar"><router-link to="/news">本會新聞</router-link></li>
        <li class="media-navbar">
          <router-link to="/report">傳媒報導</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin">
          <router-link to="/director-logs">理事長網誌</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin">
          <a href="#" class="is-check" >聯絡我們</a>
        </li>
      </template>
      <template slot="banner">
        <div id="baiduMap" style="width: 100%; height: 350px"></div>
      </template>
      <template slot="content">
        <div class="col-xs-12 col-sm-5 col-sm-offset-1 contact-left">
          <div>電話: 8796-9781</div>
          <div>傳真: 8796-9798</div>
          <div>電郵: Quiz@delta-asia.com</div>
          <div><a target="_blank" href="https://www.facebook.com/%E6%BB%99%E6%A5%AD%E7%9B%83-455469194471178/" style="color: #565656">滙業盃 Facebook</a></div>
          <div>地址: 澳門崗頂前地滙業銀行行政中心</div>
        </div>
        <div class="col-xs-12 none-padding col-sm-6 contact-right">
          <div class="one-input">
            <span>名稱</span>
            <input type="text" v-model="inputData.name">
          </div>
          <div class="one-input">
            <span>電郵</span>
            <input type="text" v-model="inputData.email">
          </div>
          <div class="one-input">
            <span>電話</span>
            <input type="text" v-model="inputData.phone">
          </div>
          <div class="one-input" style="position: relative;">
            <span style="position: absolute;top: 0%;">留言</span>
            <textarea type="text" style="margin-left: 57px" v-model="inputData.message"></textarea>
          </div>
          <div style="color: red; margin-left: 10%" v-if="tips">{{tips}}</div>
          <button @click="addPost">提交</button>

        </div>
      </template>
    </content-template>
  </div>
</template>
<script>
import contentTemplate from '../contentTemplate'
// import BMap from 'BMap'
import Vue from 'vue'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      tips: '',
      inputData: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      center: {lat: 22.1925886, lng: 113.5382812},
      markers: [{
        position: {lat: 22.1926174, lng: 113.5383756}
      }],
      CityInfo: {
        longitude: 113.549975,
        latitude: 22.195797
      }
    }
  },
  methods: {
    addPost: function () {
      var emailData = this.inputData
      var that = this
      if (emailData.name === '') {
        // console.log(111)
        this.tips = '名稱不能为空'
      } else if (emailData.phone === '') {
        this.tips = '電話不能为空'
      } else if (emailData.email === '') {
        this.tips = '電郵不能为空'
      } else if (emailData.message === '') {
        this.tips = '留言不能为空'
      } else {
        this.$axios({
          url: 'other/send_email',
          method: 'post',
          data: this.$qs.stringify(emailData)
        })
          .then(function (response) {
            if (response.data.code === 1) {
              that.tips = response.data.msg
            } else {
              that.tips = response.data.msg
            }
          })
          .catch(function (error) {
            // console.log(error)
          })
      }
    },
    ready: function () {
      var map = new BMap.Map('baiduMap')
      var point = new BMap.Point(this.CityInfo.longitude, this.CityInfo.latitude)
      map.centerAndZoom(point, 20)
      map.addControl(new BMap.MapTypeControl())
      map.enableScrollWheelZoom(true)
      map.enableDoubleClickZoom(true)

      var sContent =
        "<h4 style='margin:0 0 5px 0;padding:0.2em 0'>滙業財經集團</h4>" +
        "<p style='margin:0;line-height:1.5;font-size:13px;text-indent:2em;width: 300px'>Macau，澳門崗頂前地滙業銀行 - 行政中心</p></div>"


      var marker = new BMap.Marker(point)
      var infoWindow = new BMap.InfoWindow(sContent);  // 创建信息窗口对象

      map.addOverlay(marker)

      marker.addEventListener("click", function() {
        this.openInfoWindow(infoWindow);
        //图片加载完毕重绘infowindow
        // document.getElementById('imgDemo').onload = function () {
        //   infoWindow.redraw();   //防止在网速较慢，图片未加载时，生成的信息框高度比图片的总高度小，导致图片部分被隐藏
        // }
      })
    }
  },
  mounted: function () {
    this.ready()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .contact-left, .contact-right{
    margin-top: 60px;
  }
  .contact-left{
    font-size: 16px;
    line-height: 50px;
    text-align: left;
    color: #565656;
  }

  .contact-right{

  }

  .contact-right .one-input{
    margin-bottom: 10px;
  }

  .contact-right .one-input span{
    width:32px;
    height:50px;
    font-size:16px;
    font-family:PingFangSC-Medium;
    color:rgba(86,86,86,1);
    line-height:50px;
    margin-right: 20px;
  }
  .contact-right .one-input input{
    width:360px;
    height:41px;
    background:rgba(238,238,238,1);
    border-radius:5px;
    border:1px solid rgba(192,194,197,1);
  }
  .contact-right .one-input textarea{
    width:360px;
    height:101px;
    background:rgba(238,238,238,1);
    border-radius:5px;
    border:1px solid rgba(192,194,197,1);
  }
  .contact-right button{
    width:160px;
    height:45px;
    background:rgba(85,113,236,1);
    border-radius:23px;
    color: #ffffff;
    margin-left: 60px;
  }

  @media (max-width: 768px) {
    .contact-right .one-input input,.contact-right .one-input textarea{
      width: 250px;
    }
    .contact-right button{
      margin-bottom: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/mediaCenter/contactUs.vue